// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"465":"f39c5de6","727":"8718cef3","914":"142318db"}[chunkId] + ".chunk.js";
};